/* unplugin-vue-components disabled */import { render } from "./AIScenarioSelector.vue?vue&type=template&id=2bfcf181&scoped=true&ts=true"
import script from "./AIScenarioSelector.vue?vue&type=script&lang=ts"
export * from "./AIScenarioSelector.vue?vue&type=script&lang=ts"

import "./AIScenarioSelector.vue?vue&type=style&index=0&id=2bfcf181&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfcf181"]])

export default __exports__